import { ClinicModel } from "./ClinicModel";
import { MedicModel } from "./MedicModel";
import { OfferModel } from "./OfferModel";

export class FavouritesModel{
    clinics: ClinicModel[];
    medics: MedicModel[]
    offers: OfferModel[]
}